<template>
  <a-layout id="components-layout" class="layout">
    <Navigation />
    <Content />
    <Footer />
    <a-back-top :visibility-height="100">
      <div class="back-top-button">
        <a-icon type="arrow-up" />
      </div>
    </a-back-top>
  </a-layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import Navigation from '@/components/layouts/NavigationLayout.vue';
import Footer from '@/components/layouts/FooterLayout.vue';
import Content from '@/components/layouts/ContentLayout.vue';

const serviceSettingRoute = 'ServiceSetting';

export default {
  data() {
    return {
      publicPage: ['LoginPage', 'ServiceSetting']
    }
  },
  name: 'CommonLayout',
  components: {
    Navigation,
    Footer,
    Content
  },
  mounted() {
    this.validateServiceUri();
    this.validateSession();
  },
  computed: {
    ...mapGetters('setting', {
      serviceUri: 'getServiceUri'
    }),
    isValidServiceUri() {
      return this.isOriginWithoutPath(this.serviceUri);
    },
    route() {
      return this.$route.name;
    }
  },
  methods: {
    ...mapActions('auth', {
      getProfile: "getProfile",
      removeSession: "removeSession"
    }),

    isOriginWithoutPath(str) {
      try {
        const url = new URL(str);
        return url.pathname === '/' && !str.endsWith('/');
      } catch (error) {
        return false;
      }
    },

    inPublicPage() {
      return this.publicPage.includes(this.$route.name);
    },

    validateServiceUri() {
      if (!this.isValidServiceUri) {
        this.$router.push({name: serviceSettingRoute});
      }
    },

    async callApi(func, onError) {
      try {
        await func();
      }
      catch(error) {
        if (onError) {
          onError();
        }

        this.$message.error(error?.response?.data?.error?.message || error?.response?.data || error?.message);

        if (error?.code == 'ERR_NETWORK') {
          this.$router.push({name: 'ServiceSetting'});
        }
      }
    },

    async validateSession() {
      if (this.isValidServiceUri && !this.inPublicPage()) {
        try {
          await this.getProfile();
        }
        catch(err) {
          if (this.$route.name != 'LoginPage') {
            this.$message.error(err?.response?.data || err.message);
          }
          this.removeSession();

          if (err?.code == 'ERR_NETWORK') {
            this.$router.push({name: 'ServiceSetting'});
          } else {
            this.$router.push({name: 'LoginPage'});
          }
        } 
      }
    }
  },
  watch: {
    route(nextRoute) {
      this.validateServiceUri();
      this.validateSession();

      if (nextRoute != serviceSettingRoute && !this.isValidServiceUri) {
        this.$notification['warning']({
          message: 'Cảnh báo',
          description: 'Bạn chưa cài đặt service_uri hoặc service_uri không đúng định dạng, vui lòng cài đặt!'
        });
      }
    }
  }
};
</script>

<style>
#components-layout {
  min-height: 100%;
}

*::-webkit-scrollbar {
  width: 0.7em;
}

*::-webkit-scrollbar:horizontal {
  height: 0.7em;
}
 
*::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(252, 246, 246, 0.925);
}
 
*::-webkit-scrollbar-thumb {
  background-color: #bfbfbfcf;
}

.ant-back-top-content {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.back-top-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(24, 144, 255, 0.5);
  color: #fff;
  font-size: 24px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
  transition: opacity 0.3s, transform 0.3s;
}

.back-top-button:hover {
  opacity: 0.8;
  transform: scale(1.2);
}

.back-top-button:active {
  opacity: 1;
  transform: scale(0.8);
}
</style>